export default __webpack_public_path__ + "static/media/lp-sec02_thumbnail.1b881f8f.png";